import React, { useState, useEffect } from 'react';
import './ModalTabs.css';

const ModalWithTabs = ({ show, onClose, defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || 'one-time');
  const [overlayColor, setOverlayColor] = useState('rgba(0, 0, 0, 0.7)');

  // Update activeTab when modal opens
  useEffect(() => {
    if (show) {
      setActiveTab(defaultTab || 'one-time');
      setOverlayColor('rgba(0, 0, 0, 0.7)'); // reset overlay
    }
  }, [defaultTab, show]);

  if (!show) return null;

  const handleTabClick = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);

      // Blink effect only on tab change
      setOverlayColor('rgba(234, 229, 229, 0.8)');
      setTimeout(() => {
        setOverlayColor('rgba(0, 0, 0, 0.7)');
      }, 100);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: overlayColor,
        transition: 'background-color 0.3s ease'
      }}
      onClick={onClose}
    >
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        {/* Tab Header */}
        <div className="tab-header">
          <button
            className={activeTab === 'one-time' ? 'tab-btn active' : 'tab-btn'}
            onClick={() => handleTabClick('one-time')}
          >
            One-Time Meal
          </button>
          <button
            className={activeTab === 'meal-subscription' ? 'tab-btn active' : 'tab-btn'}
            onClick={() => handleTabClick('meal-subscription')}
          >
            Meal Subscription
          </button>
        </div>

        {/* One-Time Meal Tab */}
        {activeTab === 'one-time' && (
          <div className="tab-content">
            <div className="circle-icon">
              <img src="img/swiggy.png" alt="icon" />
              <img src="img/zomato.png" alt="icon" />
              <img src="img/paustik.png" alt="icon" />
            </div>
            <h2>Found anything you like? Order now!</h2>
            <p>Explore our full menu and order instantly!</p>

            <button
              className="swiggy-btn"
              onClick={() =>
                window.open(
                  'https://www.swiggy.com/direct/brand/156555?source=swiggy-direct&subSource=generic',
                  '_blank'
                )
              }
            >
              <img src="img/swiggy.png" alt="swiggy" />
              Order on Swiggy
            </button>
            <button
              className="swiggy-btn"
              onClick={() =>
                window.open('https://zomato.onelink.me/xqzv/wdky7lpc', '_blank')
              }
            >
              <img src="img/zomato.png" alt="zomato" />
              Order on Zomato
            </button>
            <button
              className="swiggy-btn"
              onClick={() =>
                window.open('https://paushtikkswitch.petpooja.site', '_blank')
              }
            >
              <img src="img/paustik.png" alt="paustik" />
              Order from us
            </button>
          </div>
        )}

        {/* Meal Subscription Tab */}
        {activeTab === 'meal-subscription' && (
          <div className="tab-content">
            <div className="circle-icon">
              <img src="img/paustik.png" alt="icon" />
            </div>
            <h2>Start Your Wellness Journey with a Meal Plan That Fits You</h2>
            <p>
              Let's help you pick the right plan. Talk to our team or download the app
              to explore your options.
            </p>
            <button
              onClick={() =>
                (window.location.href =
                  'https://wa.me/message/BLIDE6V5JLXDA1')
              }
              className="whatsapp-btn"
            >
              <img
                src="/img/whatsappicon.png"
                alt="whatsapp"
                className="btn-icon"
              />
              Chat with Our Agent
            </button>
            <button style={{ display: 'none' }}
              onClick={() =>
                (window.location.href = 'https://onelink.to/xgb7ab')
              }
              className="whatsapp-btn"
            >
              <img
                src="/img/paustik.png"
                alt="paustik"
                className="btn-icon"
              />
              Download Our App
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalWithTabs;
